import Emitter from 'tiny-emitter';
/**
 * @class
 * @classdesc
 * @desc 全景组件基类
 * @author songshichao <songshichao@authome.com>
 */
export class PanoComponent extends Emitter {
  constructor(initSettings) {
    super();
    this.canAutorotate = true;
    // console.log('initSettings', initSettings);
  }
  /**
   * 缩略图点击
   * @param {*} name
   */
  thumbnailClick(name) {
    console.log('thumbnailClick', name);
  }
  /**
   * 自动旋转
   * @param {*} rotate
   */
  autorotate(rotate) {
    console.log('autorotate', rotate);
  }
  /**
   * 同步场景
   */
  syncScene() {
    console.log('autorotate');
  }

  /**
   * 获取导览数据
   * @returns
   */
  getTours() {
    console.log('getTours');
    return Promise.resolve();
  }
}
